<template>
  <div>
    <div class="intro-y mt-8 text-center">
      <h1 class="text-4xl font-medium text-red mb-2">
        Welcome Back!
      </h1>
      <h2 class="text-lg font-medium mr-auto mb-2">{{ pageTitle }}</h2>
      <p>
        You will have the opportunity to update your Profile information and
        your Team information, including your Team Name, Members and Goals.
      </p>
    </div>
    <div
      v-if="donationMinimum > 0"
      class="notice-box px-5 max-w-4xl mx-auto mt-6 sm:px-20 bg-red text-white py-4 rounded-xl flex items-center"
    >
      <div class="flex items-start pb-3">
        <InfoIcon class="w-12 h-12 mr-2" />
        <div class="pt-2">
          <h4 class="font-bold text-lg">
            There will be a ${{ donationMinimum }} minimum donation required to
            activate your team.
          </h4>
          <p>
            Upon reactivation of your team, you will be directed to make your
            donation. Your team will not be live and fully activated until the
            minimum donation has been made.
          </p>
        </div>
      </div>
    </div>
    <div
      v-if="showScholarshipOffer"
      class="mx-auto mt-6 max-w-4xl rounded-2xl border-2 border-yellow-400 bg-yellow-50 px-6 py-6 text-slate-900 shadow-sm"
    >
      <p class="text-xs font-bold uppercase tracking-widest text-red mb-2">
        Need a scholarship?
      </p>
      <h4 class="text-2xl font-bold mb-2">
        We can waive the ${{ donationMinimum }} minimum donation.
      </h4>
      <p class="text-base leading-relaxed mb-4">
        We do not want the ${{ donationMinimum }} donation to keep your team
        from coming back this year. If you cannot make that donation right now,
        use the scholarship option below and we will reactivate your team today.
      </p>
      <button
        type="button"
        class="btn btn-lg bg-red text-white border-red px-6"
        :disabled="scholarshipSelected"
        @click="activateScholarship"
      >
        {{
          scholarshipSelected
            ? "Scholarship Applied"
            : "Reactivate My Team With A Scholarship"
        }}
      </button>
      <div
        v-if="scholarshipSelected"
        class="mt-4 rounded-xl bg-white px-4 py-3 text-base font-medium text-green-700"
      >
        Congrats! You have been awarded a scholarship and will not need a
        minimum donation to start your team.
      </div>
    </div>
    <div class="grid grid-cols-12 gap-6 justify-items-center">
      <ReactivateProfile
        :user="user"
        :person="person"
        :scholarship-selected="scholarshipSelected"
      />
    </div>
  </div>
</template>

<script>
import { defineComponent, onMounted, reactive, ref, computed } from "vue";
import { useRoute } from "vue-router";
import { getUser } from "@/api/users.js";
// import { getTeam } from "@/api/teams.js";
import ReactivateProfile from "./ReactivateProfile.vue";
import { useStore } from "@/store";
import { normalizeDonationMinimum } from "@/utils/teamEligibility";

export default defineComponent({
  components: {
    ReactivateProfile
  },
  setup() {
    //const store = useStore();
    const route = useRoute();
    let user = reactive({});
    let person = reactive({});
    // let team = reactive({});
    const store = useStore();
    let pageTitle = ref("Let's Reactivate Your Team");
    const appSettings = computed(
      () => store.getters["main/eventSettings"] || {}
    );
    const donationMinimum = computed(() => {
      return normalizeDonationMinimum(appSettings.value.donationMinimum);
    });
    const scholarshipSelected = ref(false);
    const showScholarshipOffer = computed(() => {
      return (
        donationMinimum.value > 0 && Boolean(appSettings.value.offerScholarship)
      );
    });

    const activateScholarship = () => {
      scholarshipSelected.value = true;
    };

    const setUser = async () => {
      let getTheUser = await getUser();
      if (route.params.user) {
        const theUserID = route.params.user;
        getTheUser = await getUser(theUserID);
      }
      // const getMyTeam = await getTeam();
      const campuses = store.state.lifeChurchCampuses.locations;

      if (getTheUser.person.lifeChurchLocation) {
        let campusName = getTheUser.person.lifeChurchLocation;
        let foundCampusValue = campuses.find(c => c.name === campusName);
        getTheUser.person.lifeChurchCampus = foundCampusValue;
      }

      Object.assign(user, getTheUser);
      Object.assign(person, getTheUser.person);
      // Object.assign(team, getMyTeam);
    };

    onMounted(async () => {
      cash("body")
        .removeClass("main")
        .removeClass("error-page")
        .removeClass("login")
        .removeClass("frontend")
        .addClass("frontend reactivate-team");
      await setUser();
    });

    return {
      pageTitle,
      user,
      person,
      donationMinimum,
      showScholarshipOffer,
      scholarshipSelected,
      activateScholarship
    };
  }
});
</script>
